<template>
  <v-main class="bg-background" scrollable>
    <header
      v-if="hasHeader"
      :class="`bg-${headerColor}`"
      class="d-flex flex-column align-center pt-14 pb-2"
    >
      <slot name="title"></slot>
    </header>
    <SoTabs v-model="value" :class="`bg-${headerColor}`" class="pl-4">
      <SoTab
        v-for="(tab, index) in tabs"
        :key="index"
        :title="tab.title"
        :icon="tab.icon"
        :icon-color="tab.iconColor"
        :disabled="tab.disabled"
      >
        <div :class="tab.noPadding ? 'pa-0' : 'pa-5'">
          <slot :name="`tab-${index}`"></slot>
        </div>
      </SoTab>
    </SoTabs>
  </v-main>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import SoTabs from "@/components/tabs/SoTabs.vue"
  import SoTab from "@/components/tabs/SoTab.vue"
  import { ITab } from "@/types/Tabs"

  interface IAdminTab extends ITab {
    noPadding?: boolean
  }

  export default defineComponent({
    components: {
      SoTabs,
      SoTab,
    },
    props: {
      modelValue: {
        type: Number,
        default: 0,
      },
      tabs: {
        type: Array as PropType<IAdminTab[]>,
        required: true,
      },
      headerColor: {
        type: String,
        default: "night-light-2",
      },
    },
    emits: ["update:modelValue"],
    computed: {
      value: {
        get() {
          return this.modelValue
        },
        set(value: number) {
          this.$emit("update:modelValue", value)
        },
      },
      hasHeader() {
        return !!this.$slots.title
      },
    },
  })
</script>

<style scoped>
  :deep(.v-tab) {
    background-color: rgb(var(--v-theme-background));
  }
  :deep(.v-tab:first-child) {
    border-radius: var(--theme-radius) 0 0 0;
  }
  :deep(.v-tab:last-child) {
    border-radius: 0 var(--theme-radius) 0 0;
  }
</style>
